import Trending from './home/Trending'

import '../css/Home.scss'

export default function Home() {
  return (
    <>
      <div className='homeWrapper'>
        <Trending />
      </div>
    </>
  )
}